import { Ticket } from 'api';
import { translate } from 'i18n';
import { DataGridColumn } from 'ui';

export const columns: DataGridColumn<Ticket>[] = [
  {
    columnSize: 'large',
    field: 'summary',
    filterable: true,
    headerName: translate('backlog.findTicketsTable.columns.summary', { namespace: 'features' }),
    sortable: true,
    type: 'string',
  },
  {
    columnSize: 'medium',
    field: 'status',
    filterable: false,
    headerName: translate('backlog.findTicketsTable.columns.status', { namespace: 'features' }),
    sortable: false,
    type: 'string',
  },
  {
    field: 'team',
    filterable: true,
    headerName: translate('backlog.findTicketsTable.columns.team', { namespace: 'features' }),
    sortable: false,
    type: 'string',
  },
  {
    field: 'request_category',
    filterable: false,
    headerName: translate('backlog.findTicketsTable.columns.category', { namespace: 'features' }),
    sortable: false,
    type: 'string',
  },
];
